class MobileMenu {
  constructor(selectors) {
    this.selectors = selectors;
  }

  init() {
    const menu = document.querySelector(this.selectors.menu);

    if (menu) {
      const triggerOpen = document.querySelector(this.selectors.triggerOpen);
      const triggerClose = document.querySelector(this.selectors.triggerClose);

      if (triggerOpen) {
        this.triggerOpen = triggerOpen;
      } else {
        throw new Error(
          `Could find trigger to open menu: "${this.selectors.triggerOpen}".`,
        );
      }

      if (triggerClose) {
        this.triggerClose = triggerClose;
      } else {
        throw new Error(
          `Could find trigger to close menu: "${this.selectors.triggerClose}".`,
        );
      }

      this.menu = menu;
      this.menuInner = menu.querySelector('.mobileMenu__inner');
      this.menuOverlay = menu.querySelector('.mobileMenu__overlay');
      this.addEventListeners();
    } else {
      throw new Error(`Could find mobile menu: "${this.selector}".`);
    }
  }

  addEventListeners() {
    this.triggerOpen.addEventListener('click', this.open);
    this.triggerClose.addEventListener('click', this.close);
    this.menuOverlay.addEventListener('click', this.close);

    this.triggerOpen.that = this;
    this.triggerClose.that = this;
    this.menuOverlay.that = this;
  }

  open(e) {
    const { that } = e.target;

    that.menu.classList.add('mobileMenu--active');
    that.menuInner.classList.add('mobileMenu--active__inner');
    that.menuOverlay.classList.add('mobileMenu--active__overlay');
  }

  close(e) {
    const { that } = e.target;

    that.menu.classList.remove('mobileMenu--active');
    that.menuInner.classList.remove('mobileMenu--active__inner');
    that.menuOverlay.classList.remove('mobileMenu--active__overlay');
  }
}

const initMobileMenus = () => {
  const mmMain = new MobileMenu({
    menu: '.mobileMenu[data-id="main"]',
    triggerOpen: '.mobileMenu__trigger--open[data-id="main"]',
    triggerClose: '.mobileMenu__trigger--close[data-id="main"]',
  });

  mmMain.init();
};

if (document.loaded) {
  initMobileMenus();
} else if (window.addEventListener) {
  window.addEventListener('load', initMobileMenus, false);
} else {
  window.attachEvent('onload', initMobileMenus);
}
